<template>
  <div name="hcm-std" id="hcm-std" class="hcm-std" style="background: #FFF;">
    <div class="title-bar">
      <div class="title -heading">UI KIT</div>
      <div class="title">
        <div class="name">Style Guide template</div>
        <div class="for">For Designer and Developer</div>
      </div>
    </div>

    <menu-std :togglePage="togglePage"
              :exButtonActive="exButtonActive"
              :exButtonGroupActive="exButtonGroupActive"
              :exCollapseActive="exCollapseActive"
              :exDropdownActive="exDropdownActive"
              :exCheckboxActive="exCheckboxActive"
              :exFileActive="exFileActive"
              :exInputActive="exInputActive"
              :exRadioActive="exRadioActive"
              :exSelectActive="exSelectActive"
              :exModalActive="exModalActive"
              :exTabActive="exTabActive" />

    <div class="contents">
      <exButton v-show="exButtonActive" />
      <exButtonGroup v-show="exButtonGroupActive" />
      <exCollapse v-show="exCollapseActive" />
      <exDropdown v-show="exDropdownActive" />
      <exCheckbox v-show="exCheckboxActive" />
      <exFile v-show="exFileActive" />
      <exInput v-show="exInputActive" />
      <exRadio v-show="exRadioActive" />
      <exSelect v-show="exSelectActive" />
      <exModal v-show="exModalActive" />
      <exTab v-show="exTabActive" />
    </div>

    <!-- <backup /> -->

  </div>
</template>

<script>
import backup from './backup'
import menuStd from './menu'
import exButton from './ex-button'
import exButtonGroup from './ex-buttongroup'
import exCollapse from './ex-collapse'
import exDropdown from './ex-dropdown'
import exCheckbox from './ex-checkbox'
import exFile from './ex-file'
import exInput from './ex-input'
import exRadio from './ex-radio'
import exSelect from './ex-select'
import exModal from './ex-modal'
import exTab from './ex-tab'

export default {
  name: 'hcm-std',
  data () {
    return {
      exButtonActive: true,
      exButtonGroupActive: false,
      exCollapseActive: false,
      exDropdownActive: false,
      exCheckboxActive: false,
      exFileActive: false,
      exInputActive: false,
      exRadioActive: false,
      exSelectActive: false,
      exModalActive: false,
      exTabActive: false,
      page: 'exButtonActive'
    }
  },
  methods: {
    togglePage (page) {
      this.exButtonActive = false
      this.exButtonGroupActive = false
      this.exCollapseActive = false
      this.exDropdownActive = false
      this.exCheckboxActive = false
      this.exFileActive = false
      this.exInputActive = false
      this.exRadioActive = false
      this.exSelectActive = false
      this.exModalActive = false
      this.exTabActive = false
      switch (page) {
        case 'exButtonActive':
          this.exButtonActive = true
          break
        case 'exButtonGroupActive':
          this.exButtonGroupActive = true
          break
        case 'exCollapseActive':
          this.exCollapseActive = true
          break
        case 'exDropdownActive':
          this.exDropdownActive = true
          break
        case 'exCheckboxActive':
          this.exCheckboxActive = true
          break
        case 'exFileActive':
          this.exFileActive = true
          break
        case 'exInputActive':
          this.exInputActive = true
          break
        case 'exRadioActive':
          this.exRadioActive = true
          break
        case 'exSelectActive':
          this.exSelectActive = true
          break
        case 'exModalActive':
          this.exModalActive = true
          break
        case 'exTabActive':
          this.exTabActive = true
          break
        default:
          this.exButtonActive = true
          break
      }
    }
  },
  components: {
    backup,
    menuStd,
    exButton,
    exButtonGroup,
    exCollapse,
    exDropdown,
    exCheckbox,
    exFile,
    exInput,
    exRadio,
    exSelect,
    exModal,
    exTab
  }
}
</script>

<style src="./custom.scss" lang="scss" scoped></style>


// WEBPACK FOOTER //
// component.vue?59081647